import { useNavigate, useLocation } from 'react-router-dom';
import { Home, LogOut, User, ArrowLeft } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export const POSLayout = ({ children, showBackButton = false, backPath = null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  const handleHome = () => {
    navigate('/dashboard');
  };

  const handleBack = () => {
    if (backPath) {
      navigate(backPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Top Header Bar */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="px-4 py-3 flex items-center justify-between">
          {/* Left: Back button (if needed) */}
          <div className="flex items-center gap-3">
            {showBackButton && (
              <Button
                variant="ghost"
                size="sm"
                onClick={handleBack}
                className="flex items-center gap-2"
              >
                <ArrowLeft size={18} />
                Back
              </Button>
            )}
            <h1 className="text-xl font-bold text-gray-800">
              {localStorage.getItem("restaurant") + " WaiterMan POS"}
            </h1>
          </div>

          {/* Right: Home, User, Logout */}
          <div className="flex items-center gap-2">
            {/* Home Button */}
            <Button
              variant="outline"
              size="sm"
              onClick={handleHome}
              className="flex items-center gap-2"
            >
              <Home size={16} />
              Home
            </Button>

            {/* User Info */}
            {user && (
              <div className="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg">
                <User size={16} className="text-gray-600" />
                <span className="text-sm font-medium text-gray-700">
                  {user.full_name || user.email}
                </span>
              </div>
            )}

            {/* Logout Button */}
            <Button
              variant="destructive"
              size="sm"
              onClick={handleLogout}
              className="flex items-center gap-2"
            >
              <LogOut size={16} />
              Logout
            </Button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <main>
        {children}
      </main>
    </div>
  );
};
